import React from "react";
import { useTranslation } from "react-i18next";
import "./Hero.css";

// Assets imports
import imgLeft1 from "../../../assets/images/home/page1-left1.webp";
import imgLeft1Zh from "../../../assets/images/home/page1-left1_zh.webp";
import imgLeft2 from "../../../assets/images/home/page1-left2.webp";
import imgLeft3 from "../../../assets/images/home/page1-left3.webp";
import imgCharacter from "../../../assets/images/home/page1-character.webp";
import imgGrammarNotes from "../../../assets/images/home/page1-grammar-notes.webp";
import imgGrammarNotesZh from "../../../assets/images/home/page1-grammar-notes_zh.webp";
import imgGrammar from "../../../assets/images/home/page1-grammar.webp";
import imgGrammarZh from "../../../assets/images/home/page1-grammar_zh.webp";
import videoHero from "../../../assets/videos/page1-mp4.mp4";

const Hero = () => {
  const { t, i18n } = useTranslation();
  const isZh = i18n.language?.startsWith("zh");

  return (
    <section className="hero-wrapper">
      <div className="hero-container">
        <h1 className="hero-title global-title">{t("home.title")}</h1>
        <p className="hero-description global-text desktop-only">{t("home.description")}</p>

        <div className="hero-visual-container">
          {/* Left Column */}
          <div className="side-column side-left desktop-only">
            <img src={isZh ? imgLeft1Zh : imgLeft1} alt="" className="visual-asset f-left-1" />
            <img src={imgLeft2} alt="" className="visual-asset f-left-2" />
            <img src={imgLeft3} alt="" className="visual-asset f-left-3" />
          </div>

          {/* Center Column: Video */}
          <div className="center-column">
            <video autoPlay loop muted playsInline className="mobile-video">
              <source src={videoHero} type="video/mp4" />
            </video>
          </div>

          {/* Mobile-only description positioned between video and assets */}
          <p className="hero-description global-text mobile-only">{t("home.description")}</p>

          {/* Right Column */}
          <div className="side-column side-right">
            <img src={isZh ? imgGrammarNotesZh : imgGrammarNotes} alt="" className="visual-asset f-right-1 desktop-only" />
            <img src={imgCharacter} alt="" className="visual-asset f-right-2" />
            <img src={isZh ? imgGrammarZh : imgGrammar} alt="" className="visual-asset f-right-3 desktop-only" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
